import { SimpleWrapper } from 'components/InputsMex/containers';
import { DropDownFilter, HideField } from 'components/InputsMex/inputs';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export const AgentesSuscriptor = ({
    name,
    options = [],
    props = {
        loading: false,
        loadingText: "Cargando...",
    }
}) => {

    const methods = useFormContext();
    const usuario = methods.watch(name);

    const mappedOptions = useMemo(
        () => options?.map(opt => ({ label: opt.usuario.nombres?.toUpperCase() + ' ' + opt.usuario.apellidos?.toUpperCase(), value: { ...opt.usuario, label: opt.usuario.nombres?.toUpperCase() + ' ' + opt.usuario.apellidos?.toUpperCase() } })) || [],
        [options],
    );

    const mappedAgentes = useMemo(
        () => {
            const usuarioFind = options?.find(opt => {
                return opt?.usuario?.cliCodigoCore === usuario?.cliCodigoCore
            });
            if (usuarioFind?.agentes !== null) {
                return usuarioFind?.agentes?.map(opt => ({ label: opt.label, value: opt })) || [];
            }
            return [];
        },
        [usuario, options],
    );

    return (
        <div className='col-12 py-4 px-3 card-login-mex container-accidentes w-100'>
            <div className="container-accidentes m-0 p-0">
                <h3 className="font-mex" style={{ fontSize: '30px' }}>
                    Información del agente
                </h3>
            </div>
            <div className="form-group mt-4">
                <SimpleWrapper
                    name={name}
                    label="Seleccione un agente"
                    showOk={false}
                    helpText={props?.loading ? props?.loadingText : null}
                    extrasClasses={"m-0 p-0"}
                >
                    <DropDownFilter
                        name={name}
                        options={mappedOptions}
                        rules={{
                            required: 'Este campo es obligatorio',
                        }}
                        loading={props?.loading}
                        loadingText={props?.loading ? props?.loadingText : null}
                    />
                </SimpleWrapper>
            </div>
            {(mappedAgentes.length > 1) && (<div className="form-group mt-4">
                <SimpleWrapper
                    name={name + '.agente'}
                    label="Seleccione un código de agente"
                    showOk={false}
                    helpText={props?.loading ? props?.loadingText : null}
                    extrasClasses={" m-0 p-0"}
                >
                    <DropDownFilter
                        name={name + '.agente'}
                        options={mappedAgentes}
                        rules={{
                            required: 'Este campo es obligatorio',
                        }}
                        loading={props?.loading}
                        loadingText={props?.loading ? props?.loadingText : null}
                    />
                </SimpleWrapper>
            </div>)}
            {mappedAgentes.length === 1 && (
                <HideField
                    show={false}
                    name={name + '.agente'}
                    defaultValue={mappedAgentes?.[0]}
                />
            )}
        </div>
    )
}
